module.exports = __webpack_public_path__ + "assets/img/square-academic-cap.0e9461de.svg";